import React from 'react';
import Col from 'antd/lib/col';
/** @author @morexlt Martin Moreira
 * Componente para mostrar datos verticalmente
 *
 * @param {string} title - Texto del label
 * @param {string} content - Contenido a mostrar
 * @param {number} fontSize - Tamaño del texto
 * @param {number} span - Span
 *
 * @requires antd:^3.6.3
 * */
const ItemCompact = ({ title, content, fontSize = 14, span = 12 }) => (
  <Col span={span}>
    <h2 style={{ fontSize }}>
      <small>{title}</small>
      <br />
      {content !== 'null' ? content : ''}
    </h2>
  </Col>
);

export default ItemCompact;
